<script setup>

import { ref, computed, inject, watch } from 'vue';
import { 
	apiModifierInfosTypeObjet,
	apiSupprimerTypeObjet } from '@/services/ServiceModele.js';
import SelecteurTypeOccurrence from '@/components/generiques/SelecteurTypeOccurrence.vue';

const emit = defineEmits(['editionTypeObjet']);

const { typeObjet } = defineProps({
  typeObjet: Object
});

const afficherBarreFlottante = inject('afficherBarreFlottante');
const appelerApiModifModele = inject('appelerApiModifModele');
const getTypeObjet = inject('getTypeObjet');
const getChampsCles = inject('getChampsCles');
const getTypeDonnee = inject('getTypeDonnee');

const typeObjetModifie = ref(getTypeObjetSelectionne());

const boutonMenu = ref(null);

watch(() => typeObjet, () => {
	reinitialiserValeurs();
});

watch(() => typeObjet?.nom, (nom) => {
	typeObjetModifie.value.nom = nom;
})

watch(() => typeObjet?.libelle, (libelle) => {
	typeObjetModifie.value.libelle = libelle;
});

watch(() => typeObjet?.typeOccurrence, (typeOcc) => {
	typeObjetModifie.value.typeOccurrence = typeOcc;
});

const itemsMenu = computed(() => {
	const items = [];
	items.push({
		libelle: 'Editer',
		icones: ['fa fa-edit'],
		groupe: 1, 
		commande: () => {
			editer();
		}
	});
	items.push({
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		groupe: 2, 
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	});
	return items;
});

function getTypeObjetSelectionne() {
	return {
		id: typeObjet?.id,
		nom: typeObjet?.nom,
		libelle: typeObjet?.libelle,
        typeObjetPere: getTypeObjet(typeObjet?.idTypeObjetPere),
        typeOccurrence: typeObjet?.typeOccurrence,
        cleAuto: typeObjet?.cleAuto,
        champsCles: getChampsCles(typeObjet).map(chpCle => {
            return {id: chpCle.id, nom: chpCle.nom, typeDonnee: getTypeDonnee(chpCle.typeDonnee)};
        })
	};
}

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu.value, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function reinitialiserValeurs() {
	typeObjetModifie.value = getTypeObjetSelectionne();
}

function modifierInfos() {
	appelerApiModifModele(apiModifierInfosTypeObjet, typeObjetModifie.value);
}

function editer() {
	basculerAffichageMenu();
	emit('editionTypeObjet', typeObjet);
}

function supprimer() {
	basculerAffichageMenu();
	appelerApiModifModele(apiSupprimerTypeObjet, typeObjet);
}

</script>

<template>
	<div class="detail-type-objet" v-if="typeObjet != null">		
		<label class="intitule">Nom :</label>
		<div class="zone-nom">
			<input type="text" class="saisie-nom" spellcheck="false" 
				v-model="typeObjetModifie.nom" 
				@keyup.enter="modifierInfos()"
				@blur="reinitialiserValeurs" />
			<button class="bouton fa-solid fa-caret-down" 
				ref="boutonMenu"
				@click.stop="basculerAffichageMenu" />
		</div>
		<label class="intitule">Libellé :</label>
		<input type="text" spellcheck="false" 
			v-model="typeObjetModifie.libelle" 
			@keyup.enter="modifierInfos()"
			@blur="reinitialiserValeurs" />
		<label class="intitule">Effectif :</label>
		<SelecteurTypeOccurrence 
		  v-model:typeOccurrence="typeObjetModifie.typeOccurrence" 
		  :desactive="true"
		  @blur="reinitialiserValeurs" />
	</div>
</template>

<style scoped>

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 5px;
	margin-bottom: 2px;
}

.detail-type-objet {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px 0px;
	margin-top: 10px;
	margin-bottom: 20px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

select {
	padding: 1px 0px;
}

</style>